import { Component, OnInit,Input } from '@angular/core';
import { VgApiService } from '@videogular/ngx-videogular/core';

@Component({
  selector: 'app-pvideo',
  templateUrl: './pvideo.component.html',
  styleUrls: ['./pvideo.component.sass']
})
export class PvideoComponent implements OnInit {
  @Input('res') response: object;
  @Input('pathToMedia') pathToMedia: string;
  api: VgApiService;
  constructor() { }

  ngOnInit(): void {
  }

  playVideo() {
    this.api.play();
  
  }

  onPlayerReady(api: VgApiService) {
    this.api = api;

    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(this.playVideo.bind(this));
   }
}
